module.exports = __webpack_public_path__ + "static/media/25_A.70d33dc3.png";